import { render, staticRenderFns } from "./ProductsAttributes.vue?vue&type=template&id=12673a1d"
import script from "./ProductsAttributes.vue?vue&type=script&lang=js"
export * from "./ProductsAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports